import { render, staticRenderFns } from "./Eventscenter.vue?vue&type=template&id=00da9394&scoped=true&"
import script from "./Eventscenter.vue?vue&type=script&lang=js&"
export * from "./Eventscenter.vue?vue&type=script&lang=js&"
import style0 from "./Eventscenter.vue?vue&type=style&index=0&id=00da9394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da9394",
  null
  
)

export default component.exports